import * as React from "react";
import { forwardRef } from "react";
const SvgIcPadlock24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11H19L21 13V20L19 22H5L3 20V13L5 11H7ZM15 7V11H9V7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7ZM11 14H13V19H11V14Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcPadlock24);
export { ForwardRef as ReactComponent };
